export class User {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  password: string;
  avatar: string;
}